import script from "./ChatPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPage.vue?vue&type=style&index=0&id=380f755a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380f755a"]])

export default __exports__